import VueCookies from 'vue-cookies'
import store from '@/store'
import router from '@/router';

import {
  getUploadToken,
  updateCdn,
  addMaterial,
  getOrganization,
  reportErrorLog,
  isBadWord
} from '@/api/commonApi.js'
import axios from 'axios'
const Qiniu = require('qiniu-js')
import {
  getWsToken
} from '@/components/interaction/indexApi.js'

export default {
  install(Vue, options) {
    Vue.prototype.getWsToken_fun = function (callback) {
      getWsToken().then((res) => {
        if (res.errCode == 0) {
          this.$cookies.set("ws_token", res.data.token);
          callback();
        }
      }).catch((err) => {
        console.log(err)
      })
    },
      // 机构信息
      Vue.prototype.org_info = function () {
        return store.getters.getOrgInfo;
      },
      Vue.prototype.org_code = function () {
        return store.getters.getOrgCode;
      }, Vue.prototype.system_sort_name = function () {
        return store.getters.getOrgSortName;
      }, Vue.prototype.checkIsHxz = function () {
        return store.getters.getOrgCode == "hxz";
      },
      // jp账号且过期
      Vue.prototype.isJpAccountAndExpired = function () {
        return store.getters.isJpAccountAndExpired;
      },
      // jp账号且口语不可用
      Vue.prototype.isJpAndSpokenDisabled = function () {
        return store.getters.getJpSpokenDisabled;
      },
      // 是否为客户端登录页
      Vue.prototype.isElectron = function () {
        // return localStorage.getItem("isElectron") == "true"
        return this.judeIsElectron();
      },
      // 是否为免费用户
      Vue.prototype.isElectronFree = function () {
        return store.getters.getElectronAccountInfo.type_id == 100;
      },
      /**
       * 上传文件的cancelToken
       * @param {Object} file required 上传的本地文件
       * @param {function} callback 成功回调，返回后台生成的文件url
       *
       * 每个使用uploadAction方法上传的文件都会记录一个cancelToken到uploadCancelToken列表中，
       * 取消上传仅需要调用uploadCancleAction方法，并传入要取消的文件信息即可
       */
      Vue.prototype.uploadCancelToken = [],
      Vue.prototype.uploadCancleAction = function (file, callback) {
        let index = this.uploadCancelToken.findIndex(e => e.id == file.id);
        if (index > -1) {
          this.uploadCancelToken[index].subscription.unsubscribe();
          callback(file)
        }
      },
      /**
       * @param {Object} file required 上传的本地文件
       * @param {function} successCallBack 成功回调，返回后台生成的文件url
       * @param {function} errCallBack 成功回调，错误回调
       * @param {function} progressCallBack 上传过程中回调，监听上传进度
       * @param {Boolean} isUploadAudio 是否为音频，区分了上传到后台的地址
       */
      Vue.prototype.uploadAction = async function ({
        file,
        successCallBack,
        errCallBack,
        progressCallBack,
        isUploadAudio
      }) {
        // 1 检测文件类型
        const filterFileType = file => {
          if (!file) {
            errCallBack();
            return;
          }
          let file_type = file.name.substring(
            file.name.lastIndexOf(".") + 1,
            file.name.length
          ).toLowerCase();
          let file_type_type = "";
          if (/\b(mp4|avi|mkv|wmv|rm|rmvb|mpeg|mpg|mov)\b/.test(file_type)) {
            file_type_type = this.media_type_id.video;
          } else if (/\b(mp3|wma|ogg|flac|aac)\b/.test(file_type)) {
            file_type_type = this.media_type_id.audio;
          } else if (/\b(jpg|jpeg|jpeg|png|gif|bmp)\b/.test(file_type)) {
            file_type_type = this.media_type_id.image;
          } else if (
            /\b(doc|docx|ppt|pptx|xls|xlsx|csv|pdf|wps|et|dps|x-ppt|xlsx)\b/.test(
              file_type
            )
          ) {
            file_type_type = this.media_type_id.doc;
          }
          return file_type_type;
        }

        // 2. 获取token
        const getUploadTokenAction = (fileType) => {
          let data = {
            media_type_id: fileType
          };
          return new Promise((resolve, reject) => {
            getUploadToken(data)
              .then(res => {
                if (res.errCode == 0) {
                  let tokenData = res.data;
                  resolve(tokenData);
                }
              })
              .catch(err => {
                reject(err);
              });
          });
        }

        // 3. 上传到七牛云 获取key和hash
        const uploadQiniu = (token) => {
          let file_type = file.name.substring(
            file.name.lastIndexOf("."),
            file.name.length
          ).toLowerCase();
          let key = (new Date().getTime()) + file_type;
          let config = {
            useCdnDomain: true,
          }
          let putExtra = {
            fname: "",
            params: {},
            mimeType: null
          };
          return new Promise((resolve, reject) => {
            let observe = {
              next(res) {
                if (
                  progressCallBack
                ) {
                  progressCallBack(res.total)
                }
              },
              error(err) {
                errCallBack(err)
                reject(err);
              },
              complete(res) {
                // 添加到后台
                if (res) {
                  resolve(res);
                }
              }
            };
            let observable = Qiniu.upload(file, key, token, putExtra, config)
            let subscription = observable.subscribe(observe)
            this.uploadCancelToken.push({
              id: file.uid,
              subscription: subscription
            })
          })
        }

        // 4. 上传到后台 获取url
        const updateFileCdnUrl = (key, cdn, media_type_id) => {
          if (isUploadAudio) {
            let data = {
              key: key,
              name: file.name,
              media_type_id: media_type_id
            };
            return new Promise((resolve, reject) => {
              addMaterial(data)
                .then(res => {
                  if (res.errCode == 0) {
                    resolve(res.data);
                  }
                })
                .catch(err => {
                  errCallBack(err)
                  reject(err);
                });
            });
          } else {
            let attributes = {
              key: key,
              cdn: cdn,
              media_type_id: media_type_id
            };
            let data = {
              attributes
            };
            return new Promise((resolve, reject) => {
              updateCdn(data)
                .then(res => {
                  if (res.errCode == 0) {
                    resolve(res.data);
                  }
                })
                .catch(err => {
                  errCallBack(err)
                  reject(err);
                });
            });
          }
        }

        const file_filter_type = filterFileType(file);

        console.log("开始上传文件：");
        console.log("1", file_filter_type);

        const tokenData = await getUploadTokenAction(file_filter_type);
        console.log("2", tokenData);

        const qiniuData = await uploadQiniu(tokenData.token);
        console.log("3", qiniuData);

        const fileData = await updateFileCdnUrl(
          qiniuData.key,
          tokenData.cdn,
          file_filter_type
        )
        successCallBack(fileData)
        console.log("4", fileData);
      },

      //判断是否为pc
      Vue.prototype.isPc = function () {
        const userAgentInfo = navigator.userAgent;
        const Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
        let flag = true;
        for (var v = 0; v < Agents.length; v++) {
          if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
          }
        }
        return flag;
      },
      Vue.prototype.isMobile = function () {
        let isPc = Vue.prototype.isPc();
        let deviceWidth = document.documentElement.clientWidth;
        return !isPc && deviceWidth < 600;
      },
      // 密码校验 由数字，字母，特殊符号组成，6位及以上密码
      Vue.prototype.validatePassword = function (str) {
        var reg = /^([0-9a-zA-Z]|[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]){6,18}$/;
        return reg.test(str)
      },
      //显示题型
      Vue.prototype.questionTitle = function (type) {
        const questionObj = {
          "1": "单选",
          "2": "多选",
          "3": "解析",
          "4": "阅读",
          "7": "填空",
          "8": "听力",
          "9": "判断",
          "11": "填空",
          "12": "阅读",
        }
        return questionObj[type];
      },
      // 使用
      Vue.prototype.format = function (timestamp, format) {
        Date.prototype.format = function (format) {
          var date = {
            "M+": this.getMonth() + 1,
            "d+": this.getDate(),
            "h+": this.getHours(),
            "m+": this.getMinutes(),
            "s+": this.getSeconds(),
            "q+": Math.floor((this.getMonth() + 3) / 3),
            "S+": this.getMilliseconds()
          };
          if (/(y+)/i.test(format)) {
            format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
          }
          for (var k in date) {
            if (new RegExp("(" + k + ")").test(format)) {
              format = format.replace(RegExp.$1, RegExp.$1.length == 1 ?
                date[k] : ("00" + date[k]).substr(("" + date[k]).length));
            }
          }
          return format;
        }
        var newDate = new Date();
        newDate.setTime(timestamp * 1000);
        return newDate.format(format);
      },
      Vue.prototype.uploadFile_copy = function (media_type_id, file, callback, callback2, show_text, parmars) {
        // if(show_text){
        //     this.$loading.show(show_text)
        // }
        let options = {
          quality: 0.4,
          noCompressIfLarger: true
        }
        getUploadToken({
          media_type_id: media_type_id
        }).then((res) => {
          if (res.errCode == 0) {
            this.uploader_token = _.cloneDeep(res.data);
            if (file.size > (1024 * 1024 * 2)) {
              options.quality = file.size > (1024 * 1024 * 6) ? 0.4 : 0.6;
              Qiniu.compressImage(file, options).then(data => {
                var observable = Qiniu.upload(data.dist, this.uploader_token.key, this.uploader_token.token, {
                  mimeType: ["image/png", "image/jpeg", "image/gif", 'image/jpg']
                  // mimeType: ['image/gif']
                })
                var subscription = observable.subscribe('', '', complet_func) // 上传开始
              })
            } else {
              var observable = Qiniu.upload(file, this.uploader_token.key, this.uploader_token.token, {
                mimeType: ["image/png", "image/jpeg", "image/gif", 'image/jpg']
                // mimeType: ['image/gif']
              })
              var subscription = observable.subscribe('', '', complet_func) // 这样传参形式也可以
            }
          }

          function complet_func(res) {
            updateCdn({
              attributes: {
                key: res.key,
                cdn: 'CDN_QINIU',
                media_type_id: media_type_id,
              }
            }).then((resl) => {
              if (resl.errCode == 0) {
                if (callback2) {
                  callback(resl.data, callback2);
                } else {
                  callback(resl.data, parmars);
                  // if(show_text){
                  //     this.$loading.hide()
                  // }
                }
              }
            }).catch(err => {
              // if(show_text){
              //     this.$loading.hide()
              // }
              console.log(err)
            })
          }
        })
      },
      Vue.prototype.uploadFile = function (media_type_id, file, url, callback, calback2, show_text) {
        if (show_text) {
          this.$loading.show("投屏中...")
        }
        getUploadToken({
          media_type_id: media_type_id
        }).then((res) => {
          if (res.errCode == 0) {
            // console.log(file)
            // let uid = (new Date()).valueOf();
            this.uploader_token = _.cloneDeep(res.data);
            // this.uploader_token.key = uid + "." + file.type.slice(-3);

            let _this = this;
            const axiosInstance = axios.create({
              withCredentials: false
            }); //withCredentials 禁止携带cookie，带cookie在七牛上有可能出现跨域问题
            //七牛需要的token
            let formData = new FormData(); //创建form对象
            formData.append("file", file);
            formData.append("token", _this.uploader_token.token);
            formData.append("cdn", _this.uploader_token.cdn);
            // formData.append("key", _this.uploader_token.key);
            axiosInstance({
              method: 'POST',
              url: url, //上传地址
              data: formData,
              timeout: 30000, //超时时间，因为图片上传有可能需要很久
              onUploadProgress: (progressEvent) => {

              },
            }).then(data => {
              // callback(data);
              // 更新老师批改图片
              updateCdn({
                attributes: {
                  key: data.data.key,
                  cdn: 'CDN_QINIU',
                  media_type_id: media_type_id,
                }
              }).then((res) => {
                if (res.errCode == 0) {
                  if (calback2) {
                    callback(res.data, calback2);
                  } else {
                    callback(res.data);
                  }
                  if (show_text) {
                    this.$loading.hide()
                  }
                }
              }).catch(err => {
                console.log(err)
              })
            }).catch(function (err) {
              _this.$message.error('上传超时');
              //上传失败
            });
          }
        }).catch((err) => console.log(err))
      },
      Vue.prototype.getDeviceInfo = function (status, callback) {
        try {
          if (typeof (IMAppObj) == "undefined") {
            return false;
          }
          return true;
          let deviceInfo = IMAppObj.getDeviceInfo();
          deviceInfo = JSON.parse(deviceInfo);
          console.log(deviceInfo);
          //锁屏过滤彗行者平板
          if (status) {
            let im_boolean = this.deviceInfo.slice(0, 2).some((item, index) => {
              if (deviceInfo.brand.toLowerCase().indexOf(item.brand.toLowerCase()) > -1 && deviceInfo.model.toLowerCase().indexOf(item.model.toLowerCase()) > -1) {
                if (callback) {
                  callback();
                }
                return true;
              }
              return false;
            });
            return im_boolean;
          }
          let im_boolean = this.deviceInfo.some((item, index) => {
            if (deviceInfo.brand.toLowerCase().indexOf(item.brand.toLowerCase()) > -1 && deviceInfo.model.toLowerCase().indexOf(item.model.toLowerCase()) > -1) {
              if (callback) {
                callback();
              }
              return true;
            }
            return false;
          })
          return im_boolean;
        } catch (error) {
          console.log(error)
        }
      },
      Vue.prototype.throwErr = function (err) {
        throw new Error();
        this.$loading.hide();
      },
      Vue.prototype.getMediaClass = function (media_type_id = 1, file_suffix, exam_type_id) {
        // 文档区分 word excel ppt/pdf
        if (media_type_id == 4) {
          let pdf_type = ["pdf", "pptx", "ppt"];
          let excel_type = ["xls", "xlsx", "csv"];

          if (pdf_type.includes(file_suffix)) {
            media_type_id = 5;
          }
          if (excel_type.includes(file_suffix)) {
            media_type_id = 10001;
          }
        }
        // 试卷区分 限时训练 普通试卷
        if (media_type_id == 100 && exam_type_id == 105) {
          media_type_id = 105;
        }
        return this.media_type_map_class[media_type_id];
      },
      Vue.prototype.mechanism = function (domain) {
        let action = {
          'akadm': 'akadm',
          'eleeda ': 'eleeda',
          'yuemi': 'yuemi'
        }
        return action[domain];
      },
      /**
       * @param {*} type  http response 拦截器
       */
      Vue.prototype.logout_path = function (type,reload_url) {
        if(window.location.pathname.indexOf('sso-register')>'-1'){
          console.log('第三方注册===退出')
          return;
        }
        let cache_url = localStorage.getItem("home_url");
        var url = window.location.href;
        //第三方登录页
        if (localStorage.getItem("publicChannel") || window.location.pathname.indexOf("public-login") > -1) {
          console.log("is publicChannel");
          cache_url = 'publicLogin';
          let electronParams = localStorage.getItem("electronParams") && JSON.parse(localStorage.getItem("electronParams"))
          if (electronParams && electronParams.version == "test") {
            console.log("is publicLogin has params");
            removeOrganization();
            router.replace({
              name: cache_url,
              params: {
                channel: localStorage.getItem("publicChannel"),
                client: localStorage.getItem("publicClientChannel")
              },
              query: { version: electronParams.version, token: electronParams.token }
            });
          } else {
            console.log("is publicLogin prod");
            router.replace({
              name: cache_url,
              params: {
                channel: localStorage.getItem("publicChannel"),
                client: localStorage.getItem("publicClientChannel")
              }
            });
          }
          return;
        }

        //云课件
        if (localStorage.getItem("isElectron") == "true" || this.judeIsElectron()) {
          console.log("is Electron");
          cache_url = 'electronLogin';
          let electronParams = localStorage.getItem("electronParams") && JSON.parse(localStorage.getItem("electronParams"))
          if (electronParams && electronParams.version == "test") {
            console.log("is Electron has params");
            removeOrganization();
            router.replace({
              name: cache_url,
              query: { version: electronParams.version, token: electronParams.token }
            });
          } else {
            console.log("is Electron prod");
            router.replace({
              name: cache_url
            });
          }
          this.electronWindowLoginStatus("fail");
          return;
        }

        //教培
        if (url.indexOf('jp.akadm.com') > 0 || url.indexOf('fh.akadm.com') > 0) {
          cache_url = 'jpLogin';
          console.log('cache_url', cache_url)
          store.dispatch("REMOVE_JP_RENEW_INFO");
          this.$cookies.remove("jp_teacher_class_id");
          this.$cookies.remove("jp_stu_account_id");
          this.$cookies.remove("close_first_login_toast");
        }

        //云助教
        VueCookies.remove("class_id");
        // let back_url =  localStorage.getItem('third_back_url');
        if(localStorage.getItem('third_back_url')){
          cache_url = localStorage.getItem('third_back_url');
        }
        function removeOrganization() {
          localStorage.removeItem("third_partner_token");
          localStorage.removeItem("is_bind_third_user");
          localStorage.removeItem("third_partner_name");
          localStorage.removeItem("isElectron");
          localStorage.removeItem("common_org_code");
          localStorage.removeItem("common_logo");
          localStorage.removeItem("common_favicon");
          localStorage.removeItem("common_page_title");
          localStorage.removeItem("common_system_sort_name");
          localStorage.removeItem("common_home_url");
          localStorage.removeItem("flydata_data_teacher");
          localStorage.removeItem("flydata_data_student");
          localStorage.removeItem("flydata_data_teacher_type");
          localStorage.removeItem("third_back_url");
          sessionStorage.removeItem("pageCount");
          VueCookies.remove("is_electron_first");
          VueCookies.remove("paid_modal_visible");
          VueCookies.remove("user_id");
        }
        if (cache_url) {
          if (cache_url.indexOf("http") > -1) {
            window.location.href = cache_url;
          } else {
            if (type) {
              router.replace({
                name: cache_url
              });
            } else {
              if(localStorage.getItem('third_back_url')){
                window.location.href = cache_url;
              }else{
                this.$router.replace({
                  name: cache_url
                });
              }
            }
          }
          removeOrganization();
          Vue.prototype.$flydata.flydataInit({
            name: "logout"
          });
          try {
            window.flyIo.destroy();
          } catch (error) {
            console.log("destroy");
          }
        } else {
          getOrganization()
            .then(res => {
              if (res.errCode == 0) {
                if (res.data.home_url.indexOf("http") > -1) {
                  window.location.href = res.data.home_url;
                } else {
                  if (type) {
                    router.replace({
                      name: res.data.home_url
                    });
                  } else {
                    this.$router.replace({
                      name: res.data.home_url
                    });
                  }
                }
                removeOrganization();
                Vue.prototype.$flydata.flydataInit({
                  name: "logout"
                });
                try {
                  window.flyIo.destroy();
                } catch (error) {
                  console.log("destroy");
                }
              } else {
                console.log(res.msg);
              }
            })
            .catch(err => {
              throw new Error(err);
            });
        }
      },
      Vue.prototype.reduce_img = function (file, callBack) {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function (e) {
          let url = '';
          let result = e.target.result;
          //图片大于2M压缩
          if (e.total > 1024 * 1024 * 2) {
            let img = new Image();
            img.src = result;
            img.onload = function () {
              let originWidth = img.width;
              let originHeight = img.height;
              let canvas = document.createElement("canvas");
              let context = canvas.getContext("2d");
              canvas.width = originWidth; //压缩后的宽度
              canvas.height = originHeight;
              context.clearRect(0, 0, canvas.width, canvas.height);
              context.drawImage(img, 0, 0, canvas.width, canvas.height);
              url = canvas.toDataURL("image/jpeg", 0.2);
              if (callBack) {
                callBack(url)
              }
            };
          } else {
            url = result;
            if (callBack) {
              callBack(url)
            }
          }
        };
      },
      Vue.prototype.dataURLtoBlob = function (dataurl) {
        var arr = dataurl.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], {
          type: mime
        });
      },
      Vue.prototype.numToZn = function (index, type) {
        let num = index;
        var arr1 = new Array('零', '一', '二', '三', '四', '五', '六', '七', '八', '九');
        var arr2 = new Array('', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千', '万', '十', '百', '千', '亿'); //可继续追加更高位转换值
        if (!num || isNaN(num)) {
          return "零";
        }
        var english = num.toString().split("")
        var result = "";
        for (var i = 0; i < english.length; i++) {
          var des_i = english.length - 1 - i; //倒序排列设值
          result = arr2[i] + result;
          var arr1_index = english[des_i];
          result = arr1[arr1_index] + result;
        }
        //将【零千、零百】换成【零】 【十零】换成【十】
        result = result.replace(/零(千|百|十)/g, '零').replace(/十零/g, '十');
        //合并中间多个零为一个零
        result = result.replace(/零+/g, '零');
        //移除末尾的零
        result = result.replace(/零+$/, '')
        //将【零一十】换成【零十】
        //result = result.replace(/零一十/g, '零十');//貌似正规读法是零一十
        //将【一十】换成【十】
        result = result.replace(/^一十/g, '十');
        if (type) {
          return result;
        }
        return result + '、';
      },
      Vue.prototype.formatNum = function (value) {
        // 解决数字精度问题
        // 2=>2 2.000000000001=>2.0
        if (!isNaN(value) && value % 1 === 0) {
          return value
        } else {
          if (Math.round(value) == value.toFixed(1)) {
            return parseInt(value.toFixed(1))
          }
          let isInteger = Number.isInteger(value.toFixed(1));
          return isInteger ? parseInt(value) : value.toFixed(1);
        }
      },
      Vue.prototype.collectValue = function (value) {
        return parseInt(value) >= 1000 ? "999+" : value;
      },
      Vue.prototype.filter_topic_type = function (id) {
        let topic_type = '';
        switch (id * 1) {
          case this.anserSheetType.choose:
            topic_type = '选择题';
            break;
          case this.anserSheetType.judge:
            topic_type = '判断题';
            break;
          case this.anserSheetType.pack:
            topic_type = '填空题';
            break;
          case this.anserSheetType.analysis:
            topic_type = '解析题';
            break;
          case this.anserSheetType.short:
            topic_type = '简答题';
            break;
        }
        return topic_type;
      },
      // 2. 获取token
      Vue.prototype.getUploadTokenFun = function (fileType, callBack, file) {
        let data = {
          media_type_id: fileType
        };
        return new Promise((resolve, reject) => {
          getUploadToken(data)
            .then(res => {
              if (res.errCode == 0) {
                let tokenData = res.data;
                if (callBack) {
                  callBack(tokenData, file)
                }
                resolve(tokenData);
              }
            })
            .catch(err => {
              reject(err);
            });
        });
      },
      Vue.prototype.totalUploadFile = function () {

      },
      Vue.prototype.reportErrorLogFun = function (type, error_data) {
        console.log(error_data);
        let data = {
          data: {}
        }
        let android_init = null;
        VueCookies.set('report_error_string', VueCookies.get('user_type') + new Date().getTime() + VueCookies.get('user_id'));
        try {
          if (IMAppObj) {
            android_init = IMAppObj.getDeviceInfo();
          }
        } catch (e) {
          console.log(e)
        }
        if (!VueCookies.get('class_id')) {
          data.data = {
            user_info: null,
            org_info: null,
            class_info: null,
          }
        } else {
          data.data = {
            user_info: {
              id: VueCookies.get('user_id'),
              name: VueCookies.get('user_name'),
              type_id: VueCookies.get('user_type')
            },
            org_info: {
              id: localStorage.getItem('common_org_code'),
              name: localStorage.getItem('common_system_sort_name'),
            },
            class_info: {
              id: VueCookies.get('class_id'),
            },
          }
        }
        let public_data = {
          type: type,
          page_url: window.location.href,
          error_info: {
            url: error_data && error_data.request ? error_data.request.responseURL : null,
            params: error_data && error_data.config ? error_data.config.data : null,
            data: error_data ? error_data : null
          },
          dev_info: {
            android: android_init,
            brower: navigator ? navigator.appVersion : null
          },
          cookie_unique_id: null,
          report_error_string: VueCookies.get('report_error_string')
        }
        Object.assign(data.data, public_data);
        console.log(data.data);
        reportErrorLog(data)
          .then(res => {
            if (res.errCode == 0) {
              VueCookies.remove('report_error_string')
            } else {
              console.log(res.msg);
            }
          })
          .catch(err => {
            throw new Error(err);
          });

      },
      Vue.prototype.loginPath = function () {
        let login_path = '';
        let common_org_code = localStorage.getItem('common_org_code');
        if (common_org_code == 'jp') {
          login_path = 'jpLogin';
        } else {
          login_path = 'login';
        }
        return login_path;
      },
      //加密规则
      Vue.prototype.passwordSecret = function (data) {
        let public_key = "C970ECCCFB13E0D88EEA82CBCC6703EF74A87190801D773D495E308EC5272DCE6803FCDE24AA6F36816CF43A570FB255FAE7780243959F5ADD26CECCD158F73FB6E95632E3278D1CB777571031E25423BA276A9682EECE8FFAA161300BEFEC040A5DB458C77519AAC25E5FF65064E0966BFF18D86865A80C6C94C9B4DECEC4F14FA5D8512537CA44195BDE1A954E7896D936E81D9B629E8162543CDC3938BB459553FF853A27542CA94ADAC7B23F73889F080A98606D3BCA11D5F1EA6E64EE39D8D92126F4BA256ADF109A856BCBDA4E79B01420CB7EF7F8D641673416A7610667FBD10BEF1F527F571963994FB88F98E996C590C08BD705E2CC39A85CD084E7";
        setMaxDigits(262);
        let key = new RSAKeyPair("10001", "10001", public_key, 2048);
        let post_data = window.btoa(
          encryptedString(
            key,
            JSON.stringify(data),
            RSAAPP.PKCS1Padding,
            RSAAPP.RawEncoding
          )
        );
        return post_data;
      },
      Vue.prototype.getMaisuiInfo = function (status, callback) {
        try {
          if (typeof (IMAppObj) == "undefined") {
            return;
          }
          let deviceInfo = IMAppObj.getDeviceInfo();
          deviceInfo = JSON.parse(deviceInfo);
          //锁屏过滤彗行者平板
          let im_boolean = this.deviceInfo.slice(0, 2).some((item, index) => {
            if (deviceInfo.brand.toLowerCase().indexOf(item.brand.toLowerCase()) > -1 && deviceInfo.model.toLowerCase().indexOf(item.model.toLowerCase()) > -1) {
              if (callback) {
                callback();
              }
              return true;
            }
            return false;
          });
          return im_boolean;
        } catch (error) {
          console.log(error)
        }
      },
      //判断是否为客户端环境
      Vue.prototype.judeIsElectron = function () {
        var userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.indexOf(' electron/') > -1) {
          if (userAgent.indexOf('akadm-desktop') > -1) {
            return true;
          }
        }
        return false;
      },
      //获取客户端渠道
      Vue.prototype.getDesChannel = function () {
        if (this.judeIsElectron()) {
          const remote = window.require('electron').remote;
          let sharedObject = remote.getGlobal('sharedObject');
          return sharedObject.channel;
        }
        //渠道码获取
        let channel = null;
        if (this.$route.query.channel) {
          channel = this.$route.query.channel;
        } else {
          channel = this.$cookies.get('reg_channel');
        }
        return channel || "IM000000" // 默认值
      },
      //客户端窗口关闭，最小化
      Vue.prototype.electronWindowType = function (type) {
        if (this.judeIsElectron()) {
          const ipcRenderer = window.require('electron').ipcRenderer;
          if (type == "minimize") {
            ipcRenderer.send('mainWindowBHidde');
          } else if (type == "close") {
            ipcRenderer.send('mainWindowBClose');
          } else {
            console.log("暂无该窗口类型");
          }
        }
      },
      //客户端登录成功
      Vue.prototype.electronWindowLoginStatus = function (type) {
        console.log(type);
        if (this.judeIsElectron()) {
          const ipcRenderer = window.require('electron').ipcRenderer;
          if (type == "success") {
            ipcRenderer.send('mainWindowBLoginStatus', {
              isLogin: true,
            });
          } else if (type == "fail") {
            ipcRenderer.send('mainWindowBLoginStatus', {
              isLogin: false,
            });
          } else {
            console.log("暂无该窗口类型");
          }
        }

      },
      //客户端退出
      Vue.prototype.electronWindowLogout = function () {
        if (this.judeIsElectron()) {
          const ipcRenderer = window.require('electron').ipcRenderer;
          ipcRenderer.on('logout', (e, arg) => {
            this.logout_path();
          })
        }

      },
      //客户端退出
      Vue.prototype.isBadWordsFun = function (word) {
        return new Promise((resolve, reject) => {
          let data = {
            "word": word
          }
          isBadWord(data)
              .then((res) => {
                if (res.errCode == 0) {
                  resolve(res.data.status);
                } else {
                  this.$message(res.msg);
                }
              })
              .catch((err) => {
                throw new Error(err);
              });
        })
      }
  }
}
